import React from "react";
import styles from "./RevealButton.module.scss";
import EyeOpenIcon from "images/eye-open.svg?react";
import EyeClosedIcon from "images/eye-closed.svg?react";

export const RevealButton: React.FC<{
  label: string;
  onClick: () => void;
  revealed: boolean;
}> = ({ label, onClick, revealed }) => {
  return (
    <button
      className={styles.button}
      onClick={onClick}
      aria-label={`${revealed ? "hide" : "show"} ${label}`}
    >
      {revealed ? (
        <EyeOpenIcon className={styles.icon} />
      ) : (
        <EyeClosedIcon className={styles.icon} />
      )}
    </button>
  );
};
